import { BackButton } from "../../../components/features/BackButton";
import { BoundedProgress } from "../../../components/features/BoundedProgress";
import { LoadingPage } from "../../loading-page/LoadingPage";
import { useProfiler } from "../hooks/useProfiler";
import { Profiler } from "../types/Question";
import { BackgroundMedia } from "./BackgroundMedia";
import { BeautyProfilerResultsPage } from "./results/beauty-profiler/BeautyProfilerResults";
import { FragranceProfilerResultsPage } from "./results/fragrance-profiler/FragranceProfilerResults";
import { UniversalQuestion } from "./questions/UniversalQuestion";

type UniversalProfilerPageProps = {
  profiler: Profiler;
  subtitle?: string;
  onBack: () => void;
};

export const UniversalProfilerPage = ({
  profiler,
  subtitle,
  onBack,
}: UniversalProfilerPageProps) => {
  const {
    answers,
    totalQuestions,
    isReady,
    isComplete,
    progress,
    submitAnswer,
    getCurrentQuestion,
    goBack,
    computeBeautyProfilerResults,
    computeFragranceProfilerResults,
    getBeautyProfilerResults,
    getFragranceProfilerResults,
    gift,
  } = useProfiler(profiler);


  const currentQuestion = getCurrentQuestion();

  const handleBackClick = () => {
    if (answers.size > 0) {
      goBack();
    } else if (onBack) {
      onBack();
    }
  };


  if (isComplete) {
    switch (profiler) {
      case "beauty-profiler":
        computeBeautyProfilerResults();
        console.log("Beauty Profiler Results: ", answers);
        return (
          <BeautyProfilerResultsPage
            onBack={onBack}
            getResults={getBeautyProfilerResults}
          />
        );
      case "fragrance-profiler":
        computeFragranceProfilerResults();
        console.log("Fragrance Profiler Results: ", answers);
        return <FragranceProfilerResultsPage onBack={onBack} getResults={getFragranceProfilerResults} />;
    }
  }

  if (!isReady || !currentQuestion) {
    return <LoadingPage />;
  }

  return (
    <div className="relative h-full w-full flex justify-center items-center">
      <BackgroundMedia backgroundPath={currentQuestion.backgroundPath} />
      <div className="relative z-10 h-full w-full text-white flex flex-col justify-end px-[10px] py-[34px] gap-4 max-w-[1000px]">
        <BackButton onClick={handleBackClick} />
        <UniversalQuestion
          question={currentQuestion}
          subtitle={subtitle}
          onSelect={submitAnswer}
          gift={gift}
        />
        <BoundedProgress
          current={currentQuestion.number}
          progress={Math.ceil(progress)}
          max={totalQuestions}
          variant={currentQuestion.variant}
        />
      </div>
    </div>
  );
};
